(function () {
  var els = document.querySelectorAll('.en [data-rv]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  } else {
    els.forEach(function (e) { e.classList.add('in'); });
  }

  // the buy box is the offer cards + Add to cart / Checkout buttons (snippets/endura-bundles.liquid)
  function buyBox() { return document.querySelector('.enb-actions') || document.querySelector('.product-form__buttons'); }
  function scrollToBuy(e) {
    var b = document.querySelector('.enb') || buyBox();
    if (b) { if (e) e.preventDefault(); b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }
  document.querySelectorAll('[data-en-top]').forEach(function (a) { a.addEventListener('click', scrollToBuy); });

  var bar = document.querySelector('[data-en-sticky]');
  if (!bar) return;
  var btn = bar.querySelector('[data-en-sticky-buy]');
  function setShown(show) {
    bar.classList.toggle('show', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    btn.tabIndex = show ? 0 : -1;
  }

  // Show the bar whenever none of the price boxes (offer cards + their buttons) are on screen,
  // whether the visitor is above them (mobile gallery) or has scrolled past them.
  var watched = [document.querySelector('.enb'), document.querySelector('.enb-actions')].filter(Boolean);
  if (!watched.length) { var fb = buyBox(); if (fb) watched = [fb]; }
  if ('IntersectionObserver' in window && watched.length) {
    var seen = new Map();
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      var anyVisible = false;
      seen.forEach(function (v) { if (v) anyVisible = true; });
      setShown(!anyVisible);
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    watched.forEach(function (w) { seen.set(w, false); vio.observe(w); });
  } else {
    var ticking = false;
    var update = function () {
      ticking = false;
      var t = buyBox();
      setShown(!!t && t.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  btn.addEventListener('click', function () {
    var add = document.querySelector('[data-enb-add]');
    if (add) { add.click(); return; }
    var submit = document.querySelector('.product-form__submit');
    if (submit && !submit.disabled) submit.click(); else scrollToBuy();
  });
  function syncLabel(c) {
    var label = bar.querySelector('[data-en-sticky-variant]');
    var price = c && c.querySelector('.enb-price b');
    if (label && price) label.textContent = (c.dataset.label || c.dataset.value) + ' · ' + price.textContent.trim();
  }
  syncLabel(document.querySelector('.enb-card.on'));
  document.addEventListener('click', function (e) {
    var c = e.target.closest('.enb-card');
    if (c) syncLabel(c);
  });
})();
